module.exports = __webpack_public_path__ + "static/media/icon-quick-email.e6eacaa9.svg";